module.exports = __webpack_public_path__ + "9513c65d228e8772bc78c89b18feafdd.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pili/AppData/Roaming/npm/~/pink/css/fonts/LeagueGothic/leaguegothic-italic-webfont.woff
// module id = 349
// module chunks = 0